export default __webpack_public_path__ + "static/901-53b5c23afd0efb9bf5be956ddfe5bc59.gif";